import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupCommon } from '../organization-setup.common';
import * as moment from 'moment';
import { AppAPIConfig } from 'src/app/services/app-api-config';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-conveyance-rates',
  templateUrl: './conveyance-rates.component.html',
  styleUrls: ['./conveyance-rates.component.css']
})
export class ConveyanceRatesComponent implements OnInit {

  roleList: any;
  modalFormObjList: any;
  modalForm: FormGroup;
  modalStatus: any;
  branchList: any;
  branch: any;
  formSubmitted = false;
  formErrors = OrganizationSetupCommon.conveyanceFormErrors;
  formValidationMessages = OrganizationSetupCommon.conveyanceFormValidationMessages;
  offDaysList = [{ id: "2", name: "Monday" }, { id: "3", name: "Tuesday" }, { id: "4", name: "Wednesday" }, { id: "5", name: "Thursday" }, { id: "6", name: "Friday" }, { id: "7", name: "Saturday" }, { id: "1", name: "Sunday" }]

  decimalRegex = /^-?\d*[.,]?\d{0,2}$/
  selectedRole = " ";

  constructor(private organizationSetupService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder, private modalService: NgbModal,
    private commonMessageService: CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    // this.loadConveyance();
    this.getAllBranch();

    this.modalForm.valueChanges.subscribe((data) => {
      // console.log('On change', data)
      this.logValidationErrors(this.modalForm);
    });
  }

  getAllBranch() {
    this.masterDataService.getBranch()
      .subscribe(res => {
        console.log(res);
        this.branchList = res;

        var branchIndex = -1;
        this.branchList.forEach((element, key) => {
          if (element.name == 'Pune') {
            branchIndex = key;
          }
        });
        this.branch = this.branchList[branchIndex];
        this.onChangeBranch();
      });

  }

  onChangeBranch() {
    console.log(this.branch)
    if (this.branch == 'null') {

    } else {
      this.loadConveyance()
    }
  }

  limitDecimal(event) {
    const e_val: string = event.target.value
    console.log('Change: ', e_val)

    if (!this.decimalRegex.test(e_val)) {
      console.log('Eval', e_val)
      event.target.value = Number(e_val).toFixed(2)
    }
  }

  loadConveyance() {
    this.organizationSetupService.getConveyance(this.branch.id)
      .subscribe(res => {
        console.log(res);
        this.modalFormObjList = res;
        this.loadRoles();
      });
  }

  loadRoles() {
    this.masterDataService.getRoles()
      .subscribe(res => {
        console.log(res);
        this.roleList = res;
      });
  }

  initModalForm() {
    this.modalForm = this.fb.group({
      id: [''],
      role: ['', [Validators.required]],
      effectiveDate: ['', [Validators.required]],
      allowTwoWheeler: [false],
      allowFourWheeler: [false],
      twoWheelerRate: ['', Validators.pattern(this.decimalRegex)],
      fourWheelerRate: ['', Validators.pattern(this.decimalRegex)],
      fourWheelerNonChargableRate: ['', Validators.pattern(this.decimalRegex)],
      /* branch : ['',[Validators.required]] */
    });
  }

  // Modal Code
  openModal(content, status) {
    console.log("branch", this.branch.id)
    if (this.branch.id != undefined) {
      this.modalStatus = status;
      if (!(this.modalStatus == 'edit')) {
        this.resetModalForm();
      }
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
      }, (reason) => {
      });
    } else {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select branch')
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm() {
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  compareById = (o1: any, o2: any): boolean => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };


  //----------------------
  onChangeAllowTwoWheeler() {
    const twoWheelerRateFormControl = this.modalForm.get('twoWheelerRate');
    if (this.modalForm.get('allowTwoWheeler').value) {
      twoWheelerRateFormControl.setValidators([Validators.required, Validators.pattern(this.decimalRegex)]);
    } else {
      twoWheelerRateFormControl.clearValidators();
    }
    twoWheelerRateFormControl.updateValueAndValidity();
  }

  onChangeAllowFourWheeler() {
    const fourWheelerRateControl = this.modalForm.get('fourWheelerRate');
    const fourWheelerNonChargableRateControl = this.modalForm.get('fourWheelerNonChargableRate');
    if (this.modalForm.get('allowFourWheeler').value) {
      fourWheelerRateControl.setValidators([Validators.required, Validators.pattern(this.decimalRegex)]);
      fourWheelerNonChargableRateControl.setValidators([Validators.required, Validators.pattern(this.decimalRegex)]);
    } else {
      fourWheelerRateControl.clearValidators();
      fourWheelerNonChargableRateControl.clearValidators();
    }
    fourWheelerRateControl.updateValueAndValidity();
    fourWheelerNonChargableRateControl.updateValueAndValidity();
  }

  onDeleteClick(item) {
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
        this.organizationSetupService.deleteConveyance(item.id)
          .subscribe(resp => {
            console.log(resp);
            this.changeModalFormObjList(item);
            this.commonMessageService.swalAlertWithIcon('', 'Deleted Successfully!', 'success');
          })
      }
    })
  }

  onSaveClick() {
    console.log(this.modalForm);
    this.formSubmitted = true;
    //this.logValidationErrors(this.modalForm);
    console.log("modal Form", this.modalForm)
    var saveStatus = false;
    if (this.modalForm.valid) {
      if ((this.modalForm.value.allowTwoWheeler == false || this.modalForm.value.allowTwoWheeler == null)
        && (this.modalForm.value.allowFourWheeler == false || this.modalForm.value.allowFourWheeler == null)) {
        this.commonMessageService.swalAlertWithoutIcon('', "Atleast select one conveyance allowance")
      } else {
        if (this.modalForm.value.allowTwoWheeler && (this.modalForm.value.allowFourWheeler == false || this.modalForm.value.allowFourWheeler == null)) {
          if (this.modalForm.value.twoWheelerRate == null || this.modalForm.value.twoWheelerRate == '') {
            this.commonMessageService.swalAlertWithoutIcon('', "Enter Conveyance Rate Two Wheeler")
          } else {
            saveStatus = true
          }
        } else if (this.modalForm.value.allowFourWheeler && (this.modalForm.value.allowTwoWheeler == false || this.modalForm.value.allowTwoWheeler == null)) {
          console.log("1.....")
          if ((this.modalForm.value.fourWheelerRate == null || this.modalForm.value.fourWheelerRate == '') ||
            (this.modalForm.value.fourWheelerNonChargableRate == null || this.modalForm.value.fourWheelerNonChargableRate == '')) {
            this.commonMessageService.swalAlertWithoutIcon('', "Enter Conveyance Rate Four Wheeler and Conveyance Rate Four Wheeler NonChargable")
          }
          else {
            saveStatus = true
          }
        } else if (this.modalForm.value.allowFourWheeler && this.modalForm.value.allowTwoWheeler) {
          if ((this.modalForm.value.fourWheelerRate == null || this.modalForm.value.fourWheelerRate == '') ||
            (this.modalForm.value.fourWheelerNonChargableRate == null || this.modalForm.value.fourWheelerNonChargableRate == '') ||
            (this.modalForm.value.twoWheelerRate == null || this.modalForm.value.twoWheelerRate == '')) {
            this.commonMessageService.swalAlertWithoutIcon('', "Enter Conveyance Rate Two Wheeler,Conveyance Rate Four Wheeler and Conveyance Rate Four Wheeler NonChargable")
          }
          else {
            saveStatus = true
          }
        }
      }
      console.log("saveStatus", saveStatus)
      if (saveStatus) {
        this.organizationSetupService.saveConveyance(this.getValueFromModalForm())
          .subscribe(resp => {
            console.log(resp);
            this.closeModal();
            this.changeModalFormObjList(resp);
            this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
          })
      }
    }
  }

  // ----------------------------
  getValueFromModalForm() {
    var effectiveDate = new Date(this.modalForm.value.effectiveDate.year + '-' + this.modalForm.value.effectiveDate.month + '-' + this.modalForm.value.effectiveDate.day);
    var jsonValue = {
      id: this.modalForm.value.id,
      role: this.modalForm.value.role,
      twoWheelerRate: this.modalForm.value.twoWheelerRate,
      fourWheelerRate: this.modalForm.value.fourWheelerRate,
      fourWheelerNonChargableRate: this.modalForm.value.fourWheelerNonChargableRate,
      effectiveDate: moment(effectiveDate).format("YYYY-MM-DD"),
      allowTwoWheeler: this.modalForm.value.allowTwoWheeler,
      allowFourWheeler: this.modalForm.value.allowFourWheeler,
      branch: this.branch
    }
    console.log("jsonValue", jsonValue);
    return JSON.stringify(jsonValue);
  }

  setValueToModalForm(modalObj) {
    console.log(modalObj);
    var effectiveDate = new Date(modalObj.effectiveDate);
    var effectiveDate1 = moment(effectiveDate, 'YYYY/MM/DD');
    const roleIndex = this.roleList.findIndex(item => item.id == modalObj.role.id);
    console.log("roleList", this.roleList);
    console.log("roleIndex", roleIndex);
    this.modalForm.patchValue({
      id: modalObj.id,
      role: this.roleList[roleIndex],
      twoWheelerRate: modalObj.twoWheelerRate,
      fourWheelerRate: modalObj.fourWheelerRate,
      fourWheelerNonChargableRate: modalObj.fourWheelerNonChargableRate,
      effectiveDate: { year: parseInt(effectiveDate1.format('YYYY')), month: parseInt(effectiveDate1.format('M')), day: parseInt(effectiveDate1.format('D')) },
      allowTwoWheeler: modalObj.allowTwoWheeler,
      allowFourWheeler: modalObj.allowFourWheeler,
    });
    // this.modalForm.controls.roles.setValue(modalObj.roles);
  }

  viewModalFormObj(formObj, content) {
    this.organizationSetupService.viewConveyance(formObj.id)
      .subscribe(resp => {
        this.setValueToModalForm(resp);
        this.openModal(content, 'edit');
      })
  }

  onEditClick(modalContent, formObj) {
    console.log(formObj);
    this.viewModalFormObj(formObj, modalContent);
  }

  onUpdateClick() {
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted = true;
    var saveStatus = false;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      if ((this.modalForm.value.allowTwoWheeler == false || this.modalForm.value.allowTwoWheeler == null)
        && (this.modalForm.value.allowFourWheeler == false || this.modalForm.value.allowFourWheeler == null)) {
        this.commonMessageService.swalAlertWithoutIcon('', "atleast select one conveyance allowance")
      } else {
        if (this.modalForm.value.allowTwoWheeler && (this.modalForm.value.allowFourWheeler == false || this.modalForm.value.allowFourWheeler == null)) {
          if (this.modalForm.value.twoWheelerRate == null || this.modalForm.value.twoWheelerRate == '') {
            this.commonMessageService.swalAlertWithoutIcon('', "Enter Conveyance Rate Two Wheeler")
          } else {
            saveStatus = true
          }
        } else if (this.modalForm.value.allowFourWheeler && (this.modalForm.value.allowTwoWheeler == false || this.modalForm.value.allowTwoWheeler == null)) {
          console.log("1.....")
          if ((this.modalForm.value.fourWheelerRate == null || this.modalForm.value.fourWheelerRate == '') ||
            (this.modalForm.value.fourWheelerNonChargableRate == null || this.modalForm.value.fourWheelerNonChargableRate == '')) {
            this.commonMessageService.swalAlertWithoutIcon('', "Enter Conveyance Rate Four Wheeler and Conveyance Rate Four Wheeler NonChargable")
          }
          else {
            saveStatus = true
          }
        } else if (this.modalForm.value.allowFourWheeler && this.modalForm.value.allowTwoWheeler) {
          if ((this.modalForm.value.fourWheelerRate == null || this.modalForm.value.fourWheelerRate == '') ||
            (this.modalForm.value.fourWheelerNonChargableRate == null || this.modalForm.value.fourWheelerNonChargableRate == '') ||
            (this.modalForm.value.twoWheelerRate == null || this.modalForm.value.twoWheelerRate == '')) {
            this.commonMessageService.swalAlertWithoutIcon('', "Enter Conveyance Rate Two Wheeler,Conveyance Rate Four Wheeler and Conveyance Rate Four Wheeler NonChargable")
          }
          else {
            saveStatus = true
          }
        }
      }
      console.log("saveStatus", saveStatus)
      if (saveStatus) {
        this.organizationSetupService.updateConveyance(this.getValueFromModalForm())
          .subscribe(resp => {
            console.log(resp);
            this.changeModalFormObjList(resp);
            this.closeModal();
            this.commonMessageService.swalAlertWithIcon('', 'Updated Successfully!', 'success');
          })
      }
    }
  }


  //Setting
  changeModalFormObjList(modalFormObj) {
    if (this.modalStatus == 'add') {
      this.modalFormObjList.push(modalFormObj);
    }
    if (this.modalStatus == 'edit') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if (this.modalStatus == 'delete') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }


  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      // console.log('key: ' + key + ' Abstract control: ', abstractControl)
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        // console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            // console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
